import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=b3f29f30&scoped=true&"
import script from "./ItemCreate.vue?vue&type=script&lang=js&"
export * from "./ItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./ItemCreate.vue?vue&type=style&index=0&id=b3f29f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f29f30",
  null
  
)

export default component.exports